import React, { useState } from 'react';
import ModalBox from '../ModalBox/ModalBox';
import "./PrintBox.css";

import Portrait from "../../assets/Portrait.png";  
import Landscape from "../../assets/Landscape.png"; 

export default function PrintBox({ open, onClose, onSubmit }) {
  const [orientation, setOrientation] = useState("portrait");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit(orientation);
    }
    onClose();
  };

  return (
    <ModalBox open={open} onClose={onClose} title="Save and Print" className="save-print-modal" disableBackdrop={false}>
      <p>
        Choose the print orientation before moving on. Or just save now and
        come back to print it later.
      </p>
      <form onSubmit={handleSubmit}>
        <div className="radio-row">
          <label className="radio-option">
            <div className="radio-label">
              <input
                type="radio"
                value="portrait"
                checked={orientation === "portrait"}
                onChange={() => setOrientation("portrait")}
              />
              <span>Portrait</span>
            </div>
            <img src={Portrait} alt="Portrait option" className="radio-img" />
          </label>

          <label className="radio-option">
            <div className="radio-label">
              <input
                type="radio"
                value="landscape"
                checked={orientation === "landscape"}
                onChange={() => setOrientation("landscape")}
              />
              <span>Landscape</span>
            </div>
            <img src={Landscape} alt="Landscape option" className="radio-img" />
          </label>
        </div>

        <div className="form-actions">
          <button className="blue-button" type="submit">Continue to Print</button>
        </div>
      </form>
    </ModalBox>

  );
}